import { render } from "@wordpress/element";
import App from "./FrontComponent/App";


var appRoot = document.getElementById("root-id-react-shorcode");

if (appRoot !== null) {
  const preElement = appRoot.querySelector("pre") ?? "";

  const textContent = preElement.textContent?.trim() ?? [];

  
  const JSONdata = textContent.length !== 0 ? JSON.parse(textContent) : [];


    render(<App JSONdata={JSONdata}/>, appRoot); /* */
}

// Orignal
